module.exports = __webpack_public_path__ + "img/Hacienda.7b97d60f.png";